import { Checkbox as UiCheckbox, styled } from "@mui/material"

type StyledCheckboxProps = {
    checkboxColor: "primary" | "default",
}

export const Checkbox = styled(UiCheckbox, { shouldForwardProp: prop => prop !== "checkboxColor" })<StyledCheckboxProps>(({ checkboxColor, theme }) => ({
    color: checkboxColor === "primary" ? theme.palette.primary.main : theme.palette["common/black_states"].main,

    '&.Mui-disabled': {
        color: theme.palette["_components/checkbox/default/disabled/border"].main,
    },

    '&.Mui-checked': {
        color: checkboxColor === "primary" ? theme.palette.primary.main : theme.palette["common/black_states"].main,
    },
}))